export default "__VITE_ASSET__QS5ZY7bw__"